import { i18n } from '@ecster/i18n';

export const getContractHeader = contract => {
    const { productCode, status } = contract;

    const header = i18n(`contract.objects.${productCode}`, { defaultValue: '' }) || i18n('contract.objects.other');

    return status !== 'AIP' ? header : i18n('contract.overview.aip.header');
};
